import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { saveAs } from "file-saver";
import {convertToLocalTime} from "../../utils/dateTimeConversionUtils";
import { notifyError } from "../../components/ToastContainer/Toast/Toast";
interface ApiParameter{
    filters:any;
    page:number;
    download?:boolean;
    totalPages?:number;
}
const baseURL = process.env.REACT_APP_BASE_URL;
export const fetchTransactions = createAsyncThunk(
  "ondc/transactions",
  async ({ filters, page = 1, download = false }:ApiParameter, { rejectWithValue }) => {
    try {
      const endpoint = `${baseURL}ondc/transactions`;

      const params = new URLSearchParams({
        page,
        page_size: 10,
        ...filters,
        ...(download ? { download: true } : {}),
      });

      const response = await axios.get(`${endpoint}?${params}`);
      return response.data;
    } catch (error) {
      notifyError(error.response?.data?.error||"An error occurred while fetching transactions");
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
export const downloadTransactions = createAsyncThunk(
  "ondc/transactions",
  async ({ filters, page = 1, download = true, totalPages = 10 }:ApiParameter, { rejectWithValue }) => {
    try {
      const endpoint = `${baseURL}ondc/transactions`;

      const params = new URLSearchParams({
        page,
        page_size: totalPages,
        ...filters,
        ...(download ? { download: true } : {}),
      });
      const response = await axios.get(`${endpoint}?${params}`, { responseType: "blob" });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Transactions_Report.csv");
      // return response.data;
    } catch (error) {
      notifyError("An error occurred while downloading the file");
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const initialState = {
  transactions: [],
  totalPages: 0,
  currentPage: 1,
  total:0,
  limit: 10,
  loading: false,
  error: null,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: initialState,
  reducers: {
    resetTransactions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        const transactions = Array.isArray(action.payload?.data?.transactions)
          ? action.payload.data.transactions
          : [];
        const pagination = action.payload?.data?.pagination || {};

        state.transactions = transactions.map((doc,index) => ({
          ...doc,
          id:++index,
          formatted_created_at: convertToLocalTime(doc.created_at),
          city: (doc.city==="")?"N/A":doc.city,
        })) || [];
        state.totalPages = pagination.total_pages || 1;
        state.currentPage = pagination.current_page || 1;
        state.total = pagination.total || 0;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.transactions = [];
        state.totalPages = 0;
        state.currentPage = 1;
        state.total = 0;
      });
  },
});
export const { resetTransactions } = transactionsSlice.actions;
export default transactionsSlice.reducer;
